export const SignInRoute = {
  SIGN_IN: '/sign-in'
}